import React, { useEffect } from 'react'
import HeaderTabLayout from '../components/HeaderTabLayout'
import Layout from '../components/Layout'
import CategoryView from '../components/version-4/viewForms/CategoryView'
import ProductCatalougeView from '../components/version-4/viewForms/PoductCatalougeView'
import { ROUTES } from '../shared/constants'
import { useProductCatalogue } from '../hooks/Features/useProductCatalogue'
import { useParams } from 'react-router'
import Loader from '../components/Loader'

function ViewProductCatelouge() {
  const { getProductCatalogue, catalog } = useProductCatalogue()
  const params = useParams()
  //console.log('CATALOG : ', catalog)

  useEffect(() => {
    getProductCatalogue({ productCatalougeId: params.productCatalougeId })
  }, [params.productCatalougeId])

  return (
    <Layout heading="Product Catalouge" heading2="Info" url1={ROUTES.PRODUCT_CATALOGUE} none>
      {!catalog ? (
        <Loader />
      ) : (
        <HeaderTabLayout heading="Product Catalouge" content={<ProductCatalougeView productCatalouge={catalog} />} view url={`/edit-product-catalog/${params.productCatalougeId}`} />
      )}
    </Layout>
  )
}

export default ViewProductCatelouge
